import { type Allowance } from "~/api/products/types";

import { type BasketDiscount } from "../../types";

/**
 * Free units a `numberOfProducts` allowance still covers, used to cap an add's
 * discounted units (PWEB-116). undefined unless we're adding that allowance's
 * own discount.
 *
 * No re-balance on removal (mirrors POS): freeing a covered unit while a
 * full-price line exists won't reclaim the slot.
 */
export function getNumberOfProductsCap(
  allowance: Allowance | null | undefined,
  discount: BasketDiscount | undefined
): number | undefined {
  if (
    allowance?.type === "numberOfProducts" &&
    discount?.id === allowance.discountId
  ) {
    return allowance.remaining;
  }

  return undefined;
}
